import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useProfile } from '@/hooks/useProfile';

interface PartnerProtectedRouteProps {
  children: ReactNode;
}

export const PartnerProtectedRoute: FC<PartnerProtectedRouteProps> = ({ children }) => {
  const { userProfile, isLoading } = useProfile();

  if (isLoading) {
    return <div>Cargando...</div>;
  }

  // Verificar si el usuario es partner
  if (!userProfile?.is_partner) {
    return <Navigate to="/affiliates" />;
  }

  return <>{children}</>;
};
